import React from 'react';

export const AuthContext = React.createContext({
  token: '',
  refreshToken: '',
  roles: [] as string[],
  usersName: '',
  organisationId: '',
  organisationName: '',
  userId: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setToken: (_token: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setRefreshToken: (_refreshToken: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setRoles: (_roles: string[]) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setUsersName: (_usersName: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setOrganisationId: (_organisationId: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setUserId: (_userId: string) => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setOrganisationName: (_organisationName: string) => {}
});